import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledTitleCell = styled.div`
  max-width: 180px;
  padding: 8px;
  white-space: pre-wrap;
  ${typographyV2.bodySm}
`;

export const StyledDescriptionCell = styled.div`
  width: 438px;
  padding: 8px;
  white-space: pre-wrap;
  ${typographyV2.bodySm}
`;

export const NumberCell = styled.div`
  width: 130px;
  padding: 8px;
  white-space: wrap;
  ${typographyV2.bodySm}
`;

export const Title = styled.h2`
  ${typographyV2.titleMd}
  color: var(--text-default);
  margin-bottom: 16px;
`;
